export default "__VITE_ASSET__CPdG1n5D__"